// `lots` holds the lots some page has actually asked for — a page of a list,
// a search's results, the ones a screen's rows name. It is never the whole
// collection: nothing downloads that any more.
const INITIAL_STATE = { lots: [], deliveredLots: [] };

const setLotsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Adds the lots a page needs without discarding ones already loaded, so
    // `lots` covers what has been on screen instead of the whole collection.
    // Consumers still do `lots.find(l => l.lotNo === x)` and are unaffected.
    case "MERGE_LOTS": {
      const incoming = action.payload || [];
      if (incoming.length === 0) return state;
      const byLotNo = new Map(state.lots.map((lot) => [lot.lotNo, lot]));
      incoming.forEach((lot) => {
        if (lot && lot.lotNo) byLotNo.set(lot.lotNo, lot);
      });
      return { ...state, lots: [...byLotNo.values()] };
    }
    case "GET_ALL_DELIVERED_LOTS":
      return { ...state, deliveredLots: [...action.payload] };
    case "UPLOAD_LOT":
      return {
        ...state,
        lots: action.payload
          ? [action.payload, ...state.lots]
          : [...state.lots],
      };
    case "UPDATE_LOT":
      const filteredLot = state.lots.filter(
        (lot) => lot.lotNo !== action.payload.lotNo,
      );
      return { ...state, lots: [action.payload, ...filteredLot] };
    case "DELETE_LOT":
      const updatedLotsArray = state.lots.filter(
        (lot) => lot.lotNo !== action.payload,
      );
      return { ...state, lots: updatedLotsArray };
    default:
      return state;
  }
};
export default setLotsReducer;
